export default __webpack_public_path__ + "static/media/flag_icon.335e0981.png";